<template>
    <section banner :style="{height: (button ? '500' : '320') + 'px'}">
        <div content class="d-block" v-if="banner">
            <h1 class="b-link">
                <a class="d-block" :href="banner.linkUrl" :target="banner.linkOut ? '_blank' : false" v-if="banner.linkOut">{{ banner.link }}</a>
                <span class="d-block" v-else>{{ banner.link }}</span>
            </h1>
            <h1 class="b-title">{{ banner.title }}</h1>
            <h1 class="b-desc">{{ banner.desc }}</h1>
            <Button class="b-btn" shape="circle" size="large" type="primary" v-if="!$store.state.account && button" @click="onRegister(1)">{{ $common.config.lang === 'cn' ? '免费试用' : 'Download Demo' }}</Button>
            <Button class="b-btn" shape="circle" size="large" type="primary" v-if="$store.state.account && button" @click="$common.productDownload(product, 'trial')">{{ $common.config.lang === 'cn' ? '立即下载' : 'Download' }}</Button>
        </div>
        <Carousel carousel loop dots="none" v-model="active" v-if="banner && banner.bgType === 1">
            <CarouselItem v-for="(item, index) in banner.bgAssets" :key="index">
                <div class="d-flex justify-center">
                    <img :src="item" :style="{height: (button ? '500' : '320') + 'px'}"/>
                </div>
            </CarouselItem>
        </Carousel>
        <div video v-if="banner && banner.bgType === 2">
            <Player :data="banner.bgAssets[0]"/>
        </div>
    </section>
</template>

<script type="text/javascript">
    import Player from "./Player";

    export default {
        components: {
            Player
        },
        data() {
            return {
                active: 0,
                banner: null,
                button: false,
            }
        },
        async beforeDestroy() {
            await this.$bus.off('initBanner');
        },
        async mounted() {
            this.$bus.on('initBanner', async (data, com) => {
                if (!data || !com) return;
                this.button = (this.$route.name === 'product' && data.trial ? true : false);
                await this.getBanner();
            });
        },
        methods: {
            async getBanner(){
                let res = await this.$api.getHttp('/product/banner?id=' + this.$route.query.id + '&lang=' + this.$common.config.lang);
                console.log('this.getBanner---------->', res);
                this.banner = {} = res.data.data;
            },
            async onRegister(type){
                console.log('this.onRegister---------->', type);
                this.$bus.emit('toggleContact', true, type);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Banner.vue